import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PublicRole } from "../types/roles";

export type PublicRolesSlice = {
  roles: PublicRole[];
  loading: boolean;
  getPublicRolesSuccess: boolean;
  getPublicRolesFailure: boolean;
  getPublicRolesFailureMessage: string;
};

const initialState: PublicRolesSlice = {
  roles: [],
  loading: false,
  getPublicRolesSuccess: false,
  getPublicRolesFailure: false,
  getPublicRolesFailureMessage: ""
};

const publicRolesSlice = createSlice({
  name: "publicRoles",
  initialState,
  reducers: {
    getPublicRolesStart(state) {
      state.roles = [];
      state.loading = true;
      state.getPublicRolesSuccess = false;
      state.getPublicRolesFailure = false;
      state.getPublicRolesFailureMessage = "";
    },
    getPublicRolesSuccess(state, action: PayloadAction<PublicRole[]>) {
      state.roles = action.payload;
      state.loading = false;
      state.getPublicRolesSuccess = true;
      state.getPublicRolesFailure = false;
      state.getPublicRolesFailureMessage = "";
    },
    getPublicRolesFailure(state, action: PayloadAction<string>) {
      state.roles = [];
      state.loading = false;
      state.getPublicRolesSuccess = false;
      state.getPublicRolesFailure = true;
      state.getPublicRolesFailureMessage = action.payload;
    }
  }
});

export const {
  getPublicRolesStart,
  getPublicRolesSuccess,
  getPublicRolesFailure
} = publicRolesSlice.actions;

export default publicRolesSlice.reducer;
